export default __webpack_public_path__ + "static/media/live_broadcasting_icon.204f403a.svg";